import { useEffect, useState } from "react";
import { useFuturasTareasStore } from "../store/futurasTareas";
import { FuturaTarea } from "../DTO/FuturaTarea";
import { TablaTareasFuturas } from "./TablaTareasFuturas";
import { MyNavbar } from "../elementos/Navbar";
import {globalApiError} from "../utils/generalApiError";

import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import LoadingModal from "../elementos/LoadingModal";
import ModalBasic from "../elementos/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faPlay } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";

export const FuturasTareas = () => {
  const { findAllFuturasTareas, eliminarTarea, empezarTarea } = useFuturasTareasStore();
  const [futurasTareas, setFuturasTareas] = useState<FuturaTarea[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Cargando tareas futuras...");
  const [disabled, setDisabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTareaId, setSelectedTareaId] = useState<number>(0);

  const fetchAllFuturasTareas = async () => {
    setLoadingMessage("Cargando tareas futuras...");
    setLoading(true);
    try {
      const response = await findAllFuturasTareas();
      setFuturasTareas(response);
    } catch (error) {
       toast.error(globalApiError(error)); 
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllFuturasTareas();
  }, []);

  const handleConfirmDelete = async () => {
    setDisabled(true);
    setLoadingMessage("Eliminando tarea futura...");
    setModalOpen(false);
    setLoading(true);
    try {
      await eliminarTarea(selectedTareaId);
       toast.success('Se ha eliminado correctamente'); 
      await fetchAllFuturasTareas();
    } catch (error) {
       toast.error(globalApiError(error)); 
    } finally {
      setLoading(false);
      setDisabled(false);
      
    }
  };

    const handleCloseModal =  () => {
    setModalOpen(false);
  };

      const openModal =  (id: number) => {
    setSelectedTareaId(id);
    setModalOpen(true);
  };

  const empezarTareas = async (id: number, nombre: string, descripcion: string) => {
    setDisabled(true);
    setLoadingMessage("Empezando tarea futura...");
    setLoading(true);
    try {
      await empezarTarea(id, nombre, descripcion);
       toast.success('La tarea se ha empezado correctamente'); 
      await fetchAllFuturasTareas();
    } catch (error) {
       toast.error(globalApiError(error)); 
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  return (
    <div className="div-global" style={{ padding: "0" }}>
      <LoadingModal show={loading} message={loadingMessage} />
      <MyNavbar />

      <div
        className="div-titulo"
        style={{ paddingLeft: "5%", paddingRight: "5%" }}
      >
        <h1
          className="text-center-tt"
          style={{ marginTop: "5%", marginBottom: "5%" }}
        >
          Futuras Tareas
        </h1>

        <div className="card shadow-sm  mi-card-personalizada">
          <div className="card-body p-3">
            <TablaTareasFuturas>
              {futurasTareas.length > 0 ? (
                futurasTareas.map((futuraTarea, index) => (
                  <tr key={index}>
                    <td>{futuraTarea.nombre}</td>
                    <td className="desc" title={futuraTarea.descripcion}>
                      <div className="desc-text">
                        {futuraTarea.descripcion}
                      </div>
                      </td>
                     <td>{futuraTarea.prioridad}</td>
                    <td>
                      <Link
                        to={`/editarFuturaTarea/${futuraTarea.id}`}
                        className="btn btn-sm btn-primary me-2 btn-accions"
                        aria-label="Editar futura tarea"
                        title="Editar futura tarea"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} className="medida-icono"  />
                      </Link>
                      <button
                        onClick={() => openModal(futuraTarea.id)}
                        className="btn btn-sm btn-danger me-2 btn-accions"
                        disabled={disabled}
                         aria-label="Borrar futura tarea"
                        title="Borrar futura tarea"
                      >
                        <FontAwesomeIcon icon={faTrashCan} className="medida-icono"  />
                      </button>
                      <button
                      disabled={disabled}
                          onClick={() => empezarTareas(futuraTarea.id, futuraTarea.nombre, futuraTarea.descripcion)}
                          className="btn btn-sm btn-success me-2 btn-accions"
                        aria-label="Empezar futura tarea"
                        title="Empezar futura tarea"
                      >
                        <FontAwesomeIcon icon={faPlay} className="medida-icono"  />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No hay tareas futuras.
                  </td>
                </tr>
              )}
            </TablaTareasFuturas>

            <div className="div-botones-agregar-futuras">
              <Link
                className="btn btn-primary boton-agregar mt-3"
                to={"/crearFuturaTarea"}
              >
                <p className="title-botones"> Agregar Tarea</p>
              </Link>
            </div>
              <ModalBasic
                show={modalOpen}
                onClose={handleCloseModal}
                onConfirm={handleConfirmDelete}
              />
          </div>
        </div>
      </div>
    </div>
  );
};
